import { render, staticRenderFns } from "./szTips.vue?vue&type=template&id=72068fe7&scoped=true&"
import script from "./szTips.vue?vue&type=script&lang=js&"
export * from "./szTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72068fe7",
  null
  
)

export default component.exports